module.exports = __webpack_public_path__ + "img/deep.60835e4e.png";